import executeQuery from "../lib/db.js"

export async function getList() {
	const rows = await executeQuery({
		query: `
			SELECT
				*
			FROM
				recipes.recipes
			ORDER BY
				recipe
		`,
	})

	return rows
}
